/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestSteamOptions interface.
 */
export function instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestSteamOptions(value) {
    if (!('WebFlow' in value) || value['WebFlow'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestSteamOptionsFromJSON(json) {
    return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestSteamOptionsFromJSONTyped(json, false);
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestSteamOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'WebFlow': json['WebFlow'],
    };
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestSteamOptionsToJSON(json) {
    return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestSteamOptionsToJSONTyped(json, false);
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestSteamOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'WebFlow': value['WebFlow'],
    };
}
//# sourceMappingURL=FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestSteamOptions.js.map